import { render, staticRenderFns } from "./FullAlert.vue?vue&type=template&id=478f1c94&scoped=true&lang=pug"
import script from "./FullAlert.vue?vue&type=script&lang=ts"
export * from "./FullAlert.vue?vue&type=script&lang=ts"
import style0 from "./FullAlert.vue?vue&type=style&index=0&id=478f1c94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f1c94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478f1c94')) {
      api.createRecord('478f1c94', component.options)
    } else {
      api.reload('478f1c94', component.options)
    }
    module.hot.accept("./FullAlert.vue?vue&type=template&id=478f1c94&scoped=true&lang=pug", function () {
      api.rerender('478f1c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/CustomAlert/FullAlert.vue"
export default component.exports